import { Feature } from 'ol';
import { Layer, Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Geometry } from 'ol/geom';
import { StyleLike } from 'ol/style/Style';
import * as React from 'react';
import { Omrade } from '@/domain/omrader';
import { wktObjectToFeature } from '@/utils/SpatialHelper';
import { featureStyle } from '../style/Style';
import { FeatureLayerType } from './FeatureLayerType';
import { MapContext } from '@/state/context/MapContext';

interface OmradeantallProps {
    antall: number;
    omrade: Omrade;
    colorString: string;
    vegobjektTypeId: number;
    visible: boolean;
}

export class Omradeantall extends React.Component<OmradeantallProps> {
    static contextType = MapContext;
    declare context: React.ContextType<typeof MapContext>;

    public static BOUNDS_KEY = 'areaBoundsWKT';

    private readonly source = new VectorSource<Feature<Geometry>>();
    private readonly layer: Layer = new VectorLayer({
        source: this.source,
        style: featureStyle as StyleLike,
    });
    private areaFeature!: Feature<Geometry>;

    componentDidMount() {
        this.updateFeature();
        this.layer.setVisible(this.props.visible);
        this.context.map.addLayer(this.layer);
    }

    componentDidUpdate(prevProps: OmradeantallProps) {
        const featureChanged =
            prevProps.antall !== this.props.antall ||
            prevProps.omrade !== this.props.omrade ||
            prevProps.colorString !== this.props.colorString ||
            prevProps.vegobjektTypeId !== this.props.vegobjektTypeId;

        if (featureChanged) {
            this.updateFeature();
        }
        if (prevProps.visible !== this.props.visible) {
            this.layer.setVisible(this.props.visible);
        }
    }

    componentWillUnmount() {
        this.context.map.removeLayer(this.layer);
    }

    private updateFeature() {
        const omrade = this.props.omrade;
        if (!omrade.senterpunkt) {
            throw new Error(`Område ${omrade.navn} mangler senterpunkt`);
        }
        if (!omrade.vegobjekt) {
            throw new Error(`Område ${omrade.navn} mangler vegobjekt`);
        }
        if (!omrade.kartutsnitt) {
            throw new Error(`Område ${omrade.navn} mangler kartutsnitt`);
        }

        const featureId = `${this.props.vegobjektTypeId}-${this.props.omrade.nummer}`;
        this.areaFeature = wktObjectToFeature(
            omrade.senterpunkt.wkt,
            featureId,
            omrade.vegobjekt.metadata.type.id,
            FeatureLayerType.FEATURE_COUNT,
            this.props.colorString
        );

        this.areaFeature.set('antall', this.props.antall);
        this.areaFeature.set(Omradeantall.BOUNDS_KEY, omrade.kartutsnitt.wkt);
        this.source.clear();
        this.source.addFeature(this.areaFeature);
    }

    render() {
        return null;
    }
}
